import classNames from "classnames";

import styles from "./UI.module.css";

/**
 * Replaces MUI's contained/primary <Button> — the only variant this app used.
 * `fullWidth` and `endIcon` keep the original call sites readable.
 */
export function Button({
    children,
    className,
    endIcon,
    fullWidth = false,
    type = "button",
    ...rest
}) {
    return (
        <button
            className={classNames(
                styles.button,
                fullWidth && styles.fullWidth,
                className,
            )}
            type={type}
            {...rest}
        >
            {children}
            {endIcon ? (
                <span className={styles.buttonEndIcon}>{endIcon}</span>
            ) : null}
        </button>
    );
}

/** `edgeEnd` mirrors MUI's IconButton edge="end" (-12px right margin). */
export function IconButton({
    children,
    className,
    edgeEnd = false,
    type = "button",
    ...rest
}) {
    return (
        <button
            className={classNames(
                styles.iconButton,
                edgeEnd && styles.iconButtonEdgeEnd,
                className,
            )}
            type={type}
            {...rest}
        >
            {children}
        </button>
    );
}
